// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1g6fW","right":"styles_right__3TvcJ"};